/** @module ProductSpec/SizeChart/IncrementSelectForm  */
define([
	"dojo/_base/declare",
	"dijit/registry",
	"csi",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/widget/FormGroupSelection",
	"csi/xml"
], function(declare, registry, csi, _, FormWidget, html, locale, FormGroupSelection, xml) {

	/**
	 * This module is an inner widget for first row of Size Chart -> Increment selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Increment" tooltip "Edit"
	 * Outer view widget = ProductSpec/SizeChart/IncrementView.js
	 * Module = ProductSpec.xml
	 * View Id = "Increment" xsi:type="Html"
	 * Template = "ProductSpec/SizeChart/IncrementView.html"
	 * ControllerClass = "ProductSpec/SizeChart/IncrementView"
	 */

	return declare(FormWidget, {
		/** @property {boolean} bSubView - true if widget used inside Increment or SizeRange view (rather then Product Group view)*/
		bSubView: false,

		/**
		 * @override
		 * Create Increment selection widget
		 */
		onDrawIncrement: function(defView, field, value, div, control, widgetParam) {
			const tr = this.getFieldRow(field);
			html.clear(tr);
			const td = html.create("td", {colspan: 3}, tr)
			const node = this.getCache().getNode(widgetParam.value);
			var group = new FormGroupSelection({
				name: "picker",
				control: control,
				widgetUniqId: csi.getUniqueId(this.id),
				checkboxLabel: locale.resource("IncrementCheckboxLabel"),
				currentValueLabel: locale.resource("IncrementCurrent"),
				currentValue: node && node.$Name,
				currentAdditionalText: "",
				dropdownLabel: locale.resource("IncrementNew"),
				store: widgetParam.store,
				value: "",
				/**
				 * Check box on click event handler
				 * Enable/Disable Increments radio group depend on "Change Increment" checked status
				 * @param {boolean} checked
				 */
				onChangeCheck: function(checked) {
					this.refreshRadioGroup(checked);
				},
				/**
				 * New Increment drop down event handler
				 */
				onChangeValue: function(value) {
					var htmlView = this.getParent().viewParent;
					htmlView.newIncrement = value;
					htmlView.refreshSaveBtn();
				},
				/**
				 * Enable/Disable Increments radio group depend on "Change Increments" checked status
				 * @param {boolean} checked
				 */
				refreshRadioGroup: function(checked) {
					const htmlView = this.getParent().viewParent;
					// Hide unused radio group
					const jGroupTolerances = $(htmlView.domNode).find(".csi-radio-group-incrementValues");
					if (checked) {
						jGroupTolerances.show();
					} else {
						jGroupTolerances.hide();
						// Uncheck checkboxes, reset selection
						_.each(jGroupTolerances.find(".dijitRadio"), function(el) {
							registry.byNode(el).set("checked", false);
						});
					}
					// Disable and clear drop down
					this.dropdownNode.set("value", "");
					this.dropdownNode.set("disabled", !checked);
					htmlView.changeIncrement = checked;
					htmlView.refreshSaveBtn();
				}
			}).placeAt(td);

			// This view can be used as sub widget for several views
			const viewParent = this.viewParent;
			viewParent.incrementForm = group;
			this.bSubView = !!viewParent.class.match("csi-view-SizeChartRevision-SizeRange");
			// If we are part of Increment view - preset MockSizeChart "Tolerances" enabled status
			if (this.bSubView) {
				group.defer(group.refreshRadioGroup);
			}

		},

		/**
		 * @override
		 * Refresh aggregate store when a new product group is selected
		 */
		onViewCreate() {
			this.viewParent.watch("newProductGroup", (attr, oldValue, newValue) => {
				const f = this.getField("SubrangeIncrement");
				this._setFieldStore(f, this.getFieldStore(f, f.getValue()));
			});
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Write Product Group value as it affects aggregate store
		 */
		onWriteFormReport(field, writer, formInfo) {
			const {newProductGroup} = this.viewParent;
			const sizeChartRevisionUrl = this.getViewNode().__Parent__;

			if (xml.isValidURL(newProductGroup)) {
				writer.changeNode(sizeChartRevisionUrl).changeAttribute("Group", xml.ATTR_REF, newProductGroup);
			}
		},
	});
});